module.exports = __webpack_public_path__ + "static/media/club & society.954a8b87.png";